(function () {
  document.querySelectorAll('[data-fragen-lola]').forEach(function (section) {
    initStars(section);
  });

  // Same twinkling-sparkle technique as flavors-lola / product-showcase-
  // lola / product-cards-lola — generated once here since this section
  // has no interactive state to regenerate them on (no product switch,
  // no hover target), just a calm decorative sky behind the wordmark.
  function initStars(section) {
    var starsContainer = section.querySelector('[data-fragen-lola-stars]');
    if (!starsContainer) return;

    var count = 24;
    for (var i = 0; i < count; i++) {
      var star = document.createElement('span');
      star.className = 'fragen-lola__star';
      star.textContent = '\u2726'; // ✦ four-pointed sparkle glyph

      var left = Math.random() * 96 + 2;
      var top = Math.random() * 90 + 5;

      star.style.setProperty('--fragen-lola-star-top', top.toFixed(1) + '%');
      star.style.setProperty('--fragen-lola-star-left', left.toFixed(1) + '%');
      star.style.setProperty('--fragen-lola-star-size', (Math.random() * 14 + 10).toFixed(1) + 'px');
      star.style.setProperty('--fragen-lola-star-opacity', (Math.random() * 0.35 + 0.25).toFixed(2));
      star.style.setProperty('--fragen-lola-star-duration', (Math.random() * 2.5 + 2.5).toFixed(1) + 's');
      star.style.setProperty('--fragen-lola-star-delay', (Math.random() * 2).toFixed(2) + 's');
      star.style.setProperty('--fragen-lola-star-drift-x', (Math.random() * 10 - 5).toFixed(1) + 'px');
      starsContainer.appendChild(star);
    }
  }
})();
